import script from "./TituloPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TituloPage.vue?vue&type=script&setup=true&lang=js"

import "./TituloPage.vue?vue&type=style&index=0&id=3b3493f6&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3493f6"]])

export default __exports__